export { default } from './Collapsible';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Collapsible/index.js